module.exports = __webpack_public_path__ + "img/PwC_Repre_Illus_Iso_05_Chatbot_RGB.ea6a31a1.png";